<template>
  <div class="py-1">
      <div class="d-flex">
          <main-calendar-action-btn :isClosed="isClosed.am" type="am"/>
          <main-calendar-action-btn :isClosed="isClosed.pm" type="pm"/>
      </div>
      <div v-for="(users, index) in data" :key="'users-' + index">
          <div v-for="(role, index) in users" :key="'role-' + index" class="d-flex justify-space-between">
              <div v-if="role.am && role.am.length">
                  <div v-for="(employee, index) in role.am" :key="'employee-am-' + index">
                      <main-calendar-action-btn :data="employee" :isClosed="isClosed.am" type="am"/>
                  </div>
              </div>
              <div v-if="(role.am && role.am.length && !role.pm.length) || (role.pm && role.pm.length && !role.am.length)" style="width: 130px;"/>
              <div v-if="role.pm && role.pm.length">
                  <div v-for="(employee, index) in role.pm" :key="'employee-pm-' + index">
                      <main-calendar-action-btn :data="employee" :isClosed="isClosed.pm" type="pm"/>
                  </div>
              </div>
          </div>
      </div>
  </div>
</template>

<script>
  import MainCalendarActionBtn from '@/views/rota/components/MainCalendarActionBtn'

  export default {
    name: 'MainCalendarDay',
    props: ['clinicData', 'openingsData', 'type', 'id'],
    data: () => ({
    }),
    computed: {
      data () {
        const data = {}
        const { type, id } = this
        const clinicData = this.clinicData[type]
        if (clinicData && clinicData[id]) {
          for (const employeeId in clinicData[id]) {
            const employee = clinicData[id][employeeId]
            data[employeeId] = employee.reduce((acc, item) => {
              const accAsArray = Object.keys(acc)
              if (!accAsArray.length) {
                acc[item.roleId] = {}
              } else {
                if (!accAsArray.find(role => role === item.roleId)) {
                  acc[item.roleId] = {}
                }
              }
              return acc
            }, {})
            for (const roleId in data[employeeId]) {
              data[employeeId][roleId] = {
                am: [],
                pm: []
              }
              const amData = Array.isArray(employee) ? employee.filter(item => item.designator === 'AM' && item.roleId === Number(roleId)) : employee
              const pmData = Array.isArray(employee) ? employee.filter(item => item.designator === 'PM' && item.roleId === Number(roleId)) : employee
              data[employeeId][roleId].am.push(...data[employeeId][roleId].am, ...amData)
              data[employeeId][roleId].pm.push(...data[employeeId][roleId].pm, ...pmData)
            }
          }
        } else {
          data[id] = {
            am: false,
            pm: false
          }
        }
        return data
      },
      isClosed () {
        if (!this.openingsData) {
          return {}
        }
        return {
          am: !this.openingsData.find(item => item.designator === 'AM').isOpen,
          pm: !this.openingsData.find(item => item.designator === 'PM').isOpen
        }
      }
    },
    components: {
      MainCalendarActionBtn
    }
  }
</script>
